(() => {
  'use strict';
  if (window.RSLQualityPass) return;
  window.RSLQualityPass = true;

  const localISODate = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    return now.toISOString().slice(0, 10);
  };

  const improveRentalDates = (scope = document) => {
    const start = scope.querySelector('[data-rslr-date-start]');
    const end = scope.querySelector('[data-rslr-date-end]');
    if (!start || !end || start.dataset.rslQualityBound) return;
    start.dataset.rslQualityBound = 'true';
    const today = localISODate();
    start.min = today;
    end.min = start.value || today;
    const sync = () => {
      end.min = start.value || today;
      if (start.value && (!end.value || end.value < start.value)) end.value = start.value;
    };
    start.addEventListener('change', sync);
    end.addEventListener('change', () => {
      if (start.value && end.value < start.value) {
        end.value = start.value;
        end.reportValidity();
      }
    });
    sync();
  };

  const improveCollectionSearch = (scope = document) => {
    scope.querySelectorAll('[data-rslux-root]').forEach((root) => {
      if (root.dataset.rslQualitySearch) return;
      root.dataset.rslQualitySearch = 'true';
      const aliases = [
        [/(microfoon|microphone)/g, ' mic vocal zang'],
        [/(speaker|luidspreker)/g, ' box pa topkast monitor'],
        [/(subwoofer|sub)/g, ' baskast laagkast'],
        [/(moving\s?head)/g, ' movinghead bewegend licht'],
        [/(televisie|monitor|display|scherm)/g, ' tv beeld video'],
        [/(truss|rigging)/g, ' constructie statief takel'],
        [/(kabel|bekabeling)/g, ' snoer leiding connector'],
        [/(dj|pioneer)/g, ' discjockey draaitafel cdj djm']
      ];
      root.querySelectorAll('[data-rslux-item][data-search]').forEach((item) => {
        const original = (item.dataset.search || '').toLocaleLowerCase('nl-NL');
        let extra = '';
        aliases.forEach(([pattern, words]) => { if (pattern.test(original)) extra += words; pattern.lastIndex = 0; });
        if (extra) item.dataset.search = `${original}${extra}`;
      });
    });
  };

  const improveQuoteExperience = (scope = document) => {
    const page = scope.querySelector?.('[data-rslr-quote-app]') || (scope.matches?.('[data-rslr-quote-app]') ? scope : null);
    if (!page || page.dataset.rslQualityExperience) return;
    page.dataset.rslQualityExperience = 'true';
    const buttons = [...page.querySelectorAll('[data-rslr-experience]')];
    if (!buttons.length) return;
    let mode = 'simple';
    try { mode = localStorage.getItem('rsl_rental_experience_v1') === 'pro' ? 'pro' : 'simple'; } catch (_) {}
    const apply = (next, announce = false) => {
      mode = next === 'pro' ? 'pro' : 'simple';
      page.dataset.rslrExperience = mode;
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.rslrExperience === mode)));
      page.querySelectorAll('[data-rslr-pro-only]').forEach((panel) => {
        if (mode === 'simple' && panel.open) panel.open = false;
      });
      try { localStorage.setItem('rsl_rental_experience_v1', mode); } catch (_) {}
      if (announce) window.dispatchEvent(new CustomEvent('rsl:analytics', { detail: { event: 'quote_experience_changed', mode } }));
    };
    buttons.forEach((button) => button.addEventListener('click', () => apply(button.dataset.rslrExperience, true)));
    apply(mode);
  };

  const installAnalyticsBridge = () => {
    if (window.RSLAnalyticsBridge) return;
    window.RSLAnalyticsBridge = true;
    const push = (event, data = {}) => {
      const payload = { event, ...data };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent('rsl:tracked', { detail: payload }));
    };
    window.addEventListener('rsl:analytics', ({ detail = {} }) => push(detail.event || 'rsl_interaction', detail));
    document.addEventListener('click', (event) => {
      const target = event.target.closest('a,button');
      if (!target) return;
      if (target.matches('[data-rslp-ai-planner] button[type="submit"]')) push('ai_brief_started');
      else if (target.matches('[data-rsl-choice-add]')) push('choice_package_added');
      else if (target.matches('[data-rslr-add-to-quote]')) push('rental_item_added', { product: target.dataset.rslrHandle || '' });
    });
    document.addEventListener('submit', (event) => {
      if (event.target.matches('.rslr-quote-form')) push('rental_request_submitted');
      if (event.target.matches('[data-rsl-choice-form]')) push('choice_helper_submitted');
    });
  };

  const init = (scope = document) => {
    improveRentalDates(scope);
    improveCollectionSearch(scope);
    improveQuoteExperience(scope);
    installAnalyticsBridge();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
